import React from "react";
import * as Mui from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import { saveIntegration } from "redux/slice/integrations";
import { Integration } from "model/integration";
import { IntegrationCalendar } from "model/integration-calendar";
import { Select } from "component/shared/select";
import { SimpleIntegrationModal } from "../../simple-integration-modal";

const mapStateToProps = (_state: RootState) => ({});
const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({ saveIntegration }, dispatch);

interface OwnProps {
	open: boolean;
	onClose: () => void;
	integration: Integration;
	integrationCalendars: IntegrationCalendar[];
	calendarId?: string;
	onCalendarChange: (calendarId: string) => void;
}

interface Props extends OwnProps, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {}

class Component extends React.Component<Props> {

	public render() {
		const { open, onClose, integration, integrationCalendars, calendarId, onCalendarChange, saveIntegration } = this.props;
		const showSaveButton = !integration.data.nylasCalendarId && !integration.data.nylasV3CalendarId;

		return (
			<SimpleIntegrationModal open={open} onClose={onClose} integration={integration}>
				<Mui.Grid container direction="column" spacing={2}>
					{integration.errored ? (
						<Mui.Grid item>
							<MuiAlert severity="error">
								<Mui.Typography>There's an issue with your integration. Please delete it and re-add it again.</Mui.Typography>
							</MuiAlert>
						</Mui.Grid>
					) : integration.data.nylasCalendarId || integration.data.nylasV3CalendarId ? (
						<Mui.Grid item>
							<MuiAlert severity="success">
								<Mui.Typography>You have successfully integrated your account to send emails and sync To Do items.</Mui.Typography>
							</MuiAlert>
						</Mui.Grid>
					) : (
						<>
							<Mui.Grid item>
								<MuiAlert severity="success">
									<Mui.Typography>You have successfully integrated your account to send emails!</Mui.Typography>
								</MuiAlert>
							</Mui.Grid>
							<Mui.Grid item>
								<MuiAlert severity="info">
									<Mui.Typography>To sync To Do items, select a Calendar from your account below.</Mui.Typography>
								</MuiAlert>
							</Mui.Grid>
							<Mui.Grid item>
								<Select
									variant="outlined" margin="dense" fullWidth placeholder="Select a Calendar"
									value={calendarId} options={integrationCalendars}
									valueExtractor={calendar => calendar.id}
									labelExtractor={calendar => calendar.name}
									optionRenderer={calendar => <Mui.ListItemText primary={calendar.name} />}
									onChange={value => onCalendarChange(value)}
								/>
							</Mui.Grid>
							{showSaveButton && (
								<Mui.Grid item>
									<Mui.Button variant="contained" color="primary"
										onClick={() => saveIntegration({ integration: {
											...integration, data: { ...integration.data, nylasV3CalendarId: calendarId }
										}})}>
										Save
									</Mui.Button>
								</Mui.Grid>
							)}
						</>
					)}
				</Mui.Grid>
			</SimpleIntegrationModal>
		);
	}

}

export const EmailCalendarModal = connect(mapStateToProps, mapDispatchToProps)(Component);
